export default "__VITE_ASSET__BCQTon6k__"